export const FooterText = {
  linksTitle: 'QUICK LINKS',
  mail: 'info@ballinvc.com',
};
